(function() {
    'use strict';

    var AuditCtrl = function(
        $scope,
        $state,
        $stateParams,
        messaggiFctr,
        auditService,
        gestioneUtenteService,
        $uibModal
    ) {

        this.auditService = auditService;
        this.auditService.reset();

        this.init = () => {
            let today = new Date();
            this.filtro = {
                canale: '',
                conversationId: '',
                dataInizio: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 0, 0, 0, 0),
                dataFine: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0),
                //durataGiorni: 1,
                esito: '',
                messaggio: '',
                tipologia: '',
                tokenSessione: '',
                utenteMito: $stateParams.codiceUtente,

                page: 1,
                size: 1000
            };

            this.searchEnabled = false;
            this.listaEventi = [];

            if (!this.auditService.datiMito) {
                this.ricaricaUtenzaMito($stateParams.codiceUtente);
            }   
        };

        this.ricaricaUtenzaMito = (codiceUtente) => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService.getDatiMito(codiceUtente)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }

                        let dtoOutput = resp.data.result;
                        this.auditService.datiMito = dtoOutput.utenzaMito;
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(
                    () => {
                        this.loading--;
                    }
                );
        };

        this.search = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            this.searchEnabled = true;

            let parametri = Object.entries(this.filtro)
                .filter(([key, value]) => value !== "" || key == "dataFine")
                .reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

            try {
                parametri.durataGiorni = Math.ceil(Math.abs(this.filtro.dataFine - this.filtro.dataInizio) / (1000 * 60 * 60 * 24));
            } catch {
                parametri.durataGiorni = 1;
            }

            this.auditService.search(parametri)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }

                        let dtoOutput = resp.data.list;
                        this.listaEventi = {
                            enableSorting: true,
                            enableHiding: false,
                            enableColumnMenus: false,
                            enableVerticalScrollbar: 0,
                            enableHorizontalScrollbar: 0,
                            paginationPageSize: 8,
                            paginationPageSizes: [8, 25, 50, 100, 250, 500, 1000],
                            columnDefs: [
                                { field: 'canale', name: 'Canale' },                
                                { field: 'client', name: 'Client' },
                                { field: 'ip', name: 'IP' },
                                { field: 'operatore', name: 'Operatore' },
                                { field: 'tokenSessione', name: 'Token sessione' },
                                { field: 'convId', name: 'Conversation ID' },
                                { field: 'tipologiaNavigazione', name: 'Tipologia navigazione' },
                                { field: 'dataEvento', name: 'Data evento', cellFilter: "date:'dd/MM/yyyy HH:mm'" },
                                { field: 'esito', name: 'Esito' },
                                { field: 'messaggio', name: 'Messaggio' },

                                { name: 'Altri dati', cellTemplate: '<div class="ui-grid-cell-contents"><a href="javascript:;"ng-click="grid.appScope.auditCtrl.showDetail(row.entity)"><span><i class="fa fa-search-plus" aria-hidden="true"></i><span></a></div>' }
                            ],
                            data: dtoOutput
                        };
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(
                    () => {
                        this.loading--;
                    }
                );
        };

        this.showDetail = (row) => {
            let template = '';
            let size = 'small';
            try {
                let dati = JSON.parse(row.json);

                template =
                    '<div class="ng-modal-overlay"></div>' +
                    '<div class="row ng-modal-dialog">' +
                        '<div class="col-md-12 ng-modal-dialog-content" style="margin-bottom:10px; margin-top:10px;">' +
                            '<h2 class="nome-dettaglio">DATI AGGIUNTIVI</h2>' +
                            '<table class="table table-striped" border="1">' +
                                '<thead><tr>' +
                                    '<th>Campo</th>' +
                                    '<th>Valore</th>' +
                                '</tr></thead><tbody>';
                if (angular.isArray(dati)) {
                    dati.forEach(cell => {
                        for (const key in cell) {
                            if (Object.hasOwn(cell, key)) {
                                const element = cell[key];
                                template += '<tr>' +
                                            '<td>' + key + '</td>' +
                                            '<td>' + element + '</td>' +
                                        '</tr>';
                            }
                        }
                    });
                } else if (angular.isObject(dati)) {
                    for (const key in dati) {
                        if (Object.hasOwn(dati, key)) {
                            const element = dati[key];
                            template += '<tr>' +
                                        '<td>' + key + '</td>' +
                                        '<td>' + element + '</td>' +
                                    '</tr>';
                        }
                    }
                }
                template +='</tbody></table>' +
                        '</div>' +
                        '<div class="modal-footer">' +
                            '<button type="button" class="btn btn-default bfd-cancel" ng-click="cancel()">Chiudi</button>' +
                        '</div>' +
                    '</div>';
            } catch (error) {
                let source = row.json;
                size = 'document';
                template =
                    '<div class="ng-modal-overlay"></div>' +
                    '<div class="row ng-modal-dialog">' +
                        '<div class="col-md-12 ng-modal-dialog-content" style="margin-bottom:10px; margin-top:10px;">' +
                            '<h2 class="nome-dettaglio">DATI AGGIUNTIVI</h2>' +
                            '<pre>' + source + '</pre>' +
                        '</div>' +
                        '<div class="modal-footer">' +
                            '<button type="button" class="btn btn-default bfd-cancel" ng-click="cancel()">Chiudi</button>' +
                        '</div>' +
                    '</div>';
            } finally {
                $uibModal.open({
                    animation: true,
                    template: template,
                    size: size,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
                        // Richiamato quando si chiude il popup
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }]
                });
            }
        };

        var calculateHeightUIGridComponent = function (gridOptions) {
            let header = gridOptions.enableFiltering ? 62 : 32;
            let footer = gridOptions.showGridFooter ? 31 : 0;
            let paging = gridOptions.enablePagination ? 33 : 0;
            let rowHeight = gridOptions.rowHeight ? gridOptions.rowHeight : 30;

            let datasourceLength = gridOptions.data ? gridOptions.data.length : 0;
            let lastPageSize = datasourceLength % gridOptions.paginationPageSize;
            let countPages = (datasourceLength - lastPageSize) / gridOptions.paginationPageSize + (lastPageSize === 0 ? 0 : 1);
            let currentPageSize = ((gridOptions.paginationCurrentPage < countPages) || !lastPageSize) ? gridOptions.paginationPageSize : lastPageSize;

            let height = ((currentPageSize * rowHeight) + (header + footer + paging));
            return height;
        };

        this.indietro = () => {
            $state.go('gestioneUtenteMito', $stateParams);
        };

        this.init();
    };

    AuditCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        'MitomMessaggiFctr',
        'MitomAuditService',
        'MitomGestioneUtenteService',
        '$uibModal'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-audit/audit.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var AuditComponent = {
        controller: AuditCtrl,
        controllerAs: 'auditCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component('mitomAudit', AuditComponent);
})();